// extracted by mini-css-extract-plugin
module.exports = {"separator":"-styles-separator-3gfG25-"};